(() => {
  'use strict';
  const one = s => document.querySelector(s);
  const all = s => [...document.querySelectorAll(s)];
  const euro = cents => new Intl.NumberFormat('de-DE', {style: 'currency', currency: 'EUR'}).format(cents / 100);
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const dataEl = one('#jelune-data');
  const data = dataEl ? JSON.parse(dataEl.textContent) : null;
  const cart = one('#cart-dialog');
  const WELCOME_CODE = 'WILLKOMMEN15';
  const doseText = n => ('' + (n) + ' ' + (n === 1 ? 'Dose' : 'Dosen'));
  const intervalText = n => n === 0.5 ? 'alle 2 Wochen' : n === 1 ? 'jeden Monat' : ('alle ' + (n) + ' Monate');
  let welcomeWanted = false;

  // Findet den passenden Abo-Plan aus der Shopify Subscriptions App zum gewählten Intervall.
  function planFor(interval) {
    if (!data || !data.sellingPlans) return null;
    const test = {
      0.5: t => /15\s*tag|2\s*woche/.test(t),
      1: t => /(^|\D)(1\s*monat|jeden monat|monatlich|30\s*tag|4\s*woche)/.test(t) || (/monat/.test(t) && !/[23]\s*monat/.test(t)),
      2: t => /2\s*monat|8\s*woche/.test(t),
      3: t => /3\s*monat|12\s*woche|13\s*woche/.test(t)
    }[interval];
    return data.sellingPlans.find(p => test && test(('' + (p.name) + ' ' + ((p.options || []).join(' '))).toLowerCase())) || null;
  }

  // Kaufauswahl auf der Seite
  const hasPurchase = !!one('#add-cart') && !!data;
  // Wie die Shopify-Kasse: Rabatt je Dose abrunden, dann mal Anzahl.
  const basePrice = data ? data.price : 3790;
  const afterDiscount = pct => basePrice - Math.floor(basePrice * pct / 100);
  const offerCents = {1: basePrice, 2: afterDiscount(10) * 2, 3: afterDiscount(15) * 3};
  const aboCents = afterDiscount(10);
  const welcomeCents = afterDiscount(15);
  const selection = () => {
    const mode = one('input[name="purchase-mode"]:checked').value;
    const pack = Number(one('input[name="pack"]:checked').value);
    const interval = Number(one('#delivery-interval').value);
    if (mode === 'subscription') return {mode, doses: 1, cents: aboCents, interval};
    return {mode: 'once', doses: pack, cents: offerCents[pack], interval: 0, welcome: pack === 1 && one('#welcome-choice').checked};
  };
  function showNotice(text) {
    const n = one('#purchase-notice');
    if (!n) return;
    n.textContent = text || '';
    n.hidden = !text;
  }
  function updateSelection() {
    const offer = selection();
    const recurring = offer.mode === 'subscription';
    one('#one-time-options').hidden = recurring;
    one('#one-time-options').disabled = recurring;
    one('#subscription-options').hidden = !recurring;
    one('#delivery-interval').disabled = !recurring;
    [one('#one-time-options'), one('#subscription-options')].forEach(pane => {
      pane.inert = pane.hidden;
      pane.setAttribute('aria-hidden', String(pane.hidden));
    });
    const eligible = !recurring && offer.doses === 1;
    one('#welcome-choice').disabled = !eligible;
    if (!eligible) one('#welcome-choice').checked = false;
    one('#welcome-choice-note').textContent = eligible ? 'Für eine einzelne Dose beim Einmalkauf.' : 'Gilt nur beim Einmalkauf einer einzelnen Dose.';
    const cents = offer.welcome ? welcomeCents : offer.cents;
    one('#pack-summary').textContent = recurring
      ? ('' + (euro(offer.cents)) + ' je Lieferung · ' + (intervalText(offer.interval)))
      : ('' + (euro(cents)) + ' · einmalig' + (offer.welcome ? ' · −15 %' : ''));
    const singlePrice = one('input[name="pack"][value="1"]').closest('label').querySelector('.pack-price');
    const singleCents = eligible && offer.welcome ? cents : offerCents[1];
    singlePrice.querySelector('strong').textContent = euro(singleCents);
    singlePrice.querySelector('span').textContent = ('' + (euro(Math.round(singleCents / .3))) + '/kg');
    one('#mobile-pack-price').textContent = recurring ? ('Abo · ' + (euro(cents)) + ' je Lieferung') : ('' + (doseText(offer.doses)) + ' · ' + (euro(cents)));
    one('#add-cart').innerHTML = ('' + (recurring ? 'Abo in den Warenkorb' : 'In den Warenkorb') + ' <span aria-hidden="true">↗</span>');
    showNotice('');
  }

  // Echter Shopify-Warenkorb
  async function getCart() {
    const r = await fetch(('' + (root) + 'cart.js'), {headers: {Accept: 'application/json'}});
    return r.json();
  }
  function welcomeEligible(c) {
    return c.items.length === 1 && c.items[0].quantity === 1 && !c.items[0].selling_plan_allocation;
  }
  async function renderCart(c) {
    c = c || await getCart();
    const items = one('#cart-items');
    items.replaceChildren();
    const recurringTotals = new Map();
    for (const item of c.items) {
      const plan = item.selling_plan_allocation;
      const el = document.createElement('article');
      el.className = 'cart-item';
      const img = document.createElement('img');
      img.src = (data && data.image) || item.image || '';
      img.alt = 'JELUNE Kollagen TriPeptide';
      const copy = document.createElement('div');
      copy.className = 'cart-item-copy';
      const h = document.createElement('h3');
      h.textContent = ('' + (doseText(item.quantity)) + (!plan && item.quantity > 1 ? ' · Vorteilspaket' : ''));
      const p1 = document.createElement('p');
      p1.textContent = ('' + (item.quantity) + ' × ' + (euro(Math.round(item.final_line_price / item.quantity))) + (plan ? ' je Lieferung' : ''));
      const strong = document.createElement('strong');
      strong.textContent = ('' + (euro(item.final_line_price)) + (plan ? ' je Lieferung' : ' einmalig'));
      const kind = document.createElement('p');
      kind.className = 'cart-order-kind';
      kind.textContent = plan ? ('Abo · ' + (plan.selling_plan.name)) : 'Einmaliger Kauf · kein Abo';
      const remove = document.createElement('button');
      remove.className = 'remove-button';
      remove.type = 'button';
      remove.textContent = 'Entfernen';
      remove.setAttribute('aria-label', ('' + (doseText(item.quantity)) + ' aus dem Warenkorb entfernen'));
      remove.addEventListener('click', async () => {
        remove.disabled = true;
        const r = await fetch(('' + (root) + 'cart/change.js'), {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify({id: item.key, quantity: 0})});
        await renderCart(await r.json());
        one('#status').textContent = 'Aus dem Warenkorb entfernt.';
        (one('#cart-items button') || one('#cart-dialog [data-close]')).focus();
      });
      copy.append(h, p1, strong, kind);
      if (!plan && item.quantity === 1 && c.items.length === 1) {
        const controls = document.createElement('div');
        controls.className = 'cart-purchase-options';
        const label = document.createElement('label');
        label.className = 'cart-welcome';
        const box = document.createElement('input');
        box.type = 'checkbox';
        box.checked = welcomeWanted;
        box.addEventListener('change', () => { welcomeWanted = box.checked; });
        label.append(box, ' Erste Bestellung · 15 % Willkommensrabatt');
        const hint = document.createElement('p');
        hint.textContent = 'Für eine einzelne Dose ohne weitere Artikel. Wird an der Kasse abgezogen.';
        controls.append(label, hint);
        copy.append(controls);
      }
      copy.append(remove);
      el.append(img, copy);
      items.append(el);
      if (plan) recurringTotals.set(plan.selling_plan.name, (recurringTotals.get(plan.selling_plan.name) || 0) + item.final_line_price);
    }
    if (!welcomeEligible(c)) welcomeWanted = false;
    all('.cart-number').forEach(el => { el.textContent = c.item_count; });
    one('#cart-total').textContent = euro(c.total_price);
    one('#cart-empty').hidden = c.item_count > 0;
    one('#cart-content').hidden = c.item_count === 0;
    const recurringBox = one('#cart-recurring');
    recurringBox.replaceChildren();
    recurringBox.hidden = recurringTotals.size === 0;
    for (const [name, cents] of recurringTotals) {
      const line = document.createElement('p');
      line.textContent = ('Danach ' + (euro(cents)) + ' je Lieferung (' + (name) + '), Versand kostenlos.');
      recurringBox.append(line);
    }
    return c;
  }
  async function addToCart() {
    const offer = selection();
    const button = one('#add-cart');
    if (!data || !data.variantId) { showNotice('Das Produkt ist gerade nicht verfügbar.'); return; }
    const line = {id: data.variantId, quantity: offer.doses};
    if (offer.mode === 'subscription') {
      const plan = planFor(offer.interval);
      if (!plan) { showNotice('Das Abo ist bald verfügbar. Bis dahin kannst du einmalig bestellen.'); return; }
      line.selling_plan = plan.id;
    }
    button.disabled = true;
    try {
      const r = await fetch(('' + (root) + 'cart/add.js'), {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify({items: [line]})});
      if (!r.ok) {
        const e = await r.json().catch(() => ({}));
        showNotice(e.description || 'Das hat leider nicht geklappt. Bitte versuche es noch einmal.');
        return;
      }
      welcomeWanted = !!offer.welcome;
      const c = await renderCart();
      one('#status').textContent = ('' + (doseText(offer.doses)) + (offer.mode === 'subscription' ? ' im Abo' : '') + ' zum Warenkorb hinzugefügt.');
      cart.showModal();
      return c;
    } finally {
      button.disabled = false;
    }
  }
  if (hasPurchase) {
    all('input[name="pack"]').forEach(radio => radio.addEventListener('change', updateSelection));
    all('input[name="purchase-mode"]').forEach(radio => radio.addEventListener('change', updateSelection));
    one('#delivery-interval').addEventListener('change', updateSelection);
    one('#welcome-choice').addEventListener('change', updateSelection);
    one('#add-cart').addEventListener('click', addToCart);
    document.body.classList.add('purchase-enhanced');
    updateSelection();
  }
  all('[data-cart-open]').forEach(button => button.addEventListener('click', async () => { await renderCart(); cart.showModal(); }));
  one('#checkout-button').addEventListener('click', async () => {
    const c = await getCart();
    const code = welcomeWanted && welcomeEligible(c) ? ('?discount=' + (WELCOME_CODE)) : '';
    window.location.href = ('' + (root) + 'checkout' + (code));
  });
  all('[data-close]').forEach(button => button.addEventListener('click', () => button.closest('dialog').close()));

  // Produktbild groß ansehen
  const productImage = one('#product-image-dialog');
  const zoomToggle = one('.image-zoom-toggle');
  // Galerie: kleine Bilder wechseln das große Bild
  const galleryMain = one('#gallery-main');
  const dialogImage = productImage ? productImage.querySelector('img') : null;
  all('.gallery-thumb').forEach(thumb => thumb.addEventListener('click', () => {
    if (!galleryMain) return;
    galleryMain.src = thumb.dataset.src;
    galleryMain.style.objectFit = thumb.dataset.fit || 'contain';
    galleryMain.dataset.full = thumb.dataset.full;
    galleryMain.alt = thumb.dataset.alt || '';
    if (dialogImage) { dialogImage.src = thumb.dataset.full; dialogImage.alt = thumb.dataset.alt || ''; }
    all('.gallery-thumb').forEach(t => { t.classList.toggle('is-active', t === thumb); t.setAttribute('aria-pressed', String(t === thumb)); });
  }));
  if (productImage && zoomToggle) {
    one('.product-image-open').addEventListener('click', () => {
      if (dialogImage && galleryMain && galleryMain.dataset.full) { dialogImage.src = galleryMain.dataset.full; dialogImage.alt = galleryMain.alt; }
      productImage.showModal();
    });
    zoomToggle.addEventListener('click', () => {
      const enlarged = zoomToggle.getAttribute('aria-pressed') !== 'true';
      zoomToggle.setAttribute('aria-pressed', String(enlarged));
      zoomToggle.textContent = enlarged ? 'Ganzes Bild ansehen' : 'Vergrößern';
      one('#product-image-view').classList.toggle('is-enlarged', enlarged);
    });
    productImage.addEventListener('close', () => {
      zoomToggle.setAttribute('aria-pressed', 'false');
      zoomToggle.textContent = 'Vergrößern';
      one('#product-image-view').classList.remove('is-enlarged');
    });
  }
  all('dialog').forEach(dialog => dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const r = dialog.getBoundingClientRect();
    if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close();
  }));

  // Menü
  const menu = one('.menu-trigger');
  menu.addEventListener('click', () => {
    const open = menu.getAttribute('aria-expanded') !== 'true';
    menu.setAttribute('aria-expanded', String(open));
    one('#mobile-nav').hidden = !open;
  });
  all('a[href^="#"]').forEach(link => link.addEventListener('click', () => {
    const target = document.getElementById(link.getAttribute('href').slice(1));
    if (target?.tagName === 'DETAILS') target.open = true;
    one('#mobile-nav').hidden = true;
    menu.setAttribute('aria-expanded', 'false');
  }));

  // Schnellleiste auf dem Handy
  const bar = one('.mobile-product-bar');
  const hero = one('.hero');
  const purchase = one('#kauf');
  const newsletter = one('#newsletter');
  const form = one('#newsletter-form');
  if (bar && hero && purchase && newsletter) {
    const updateBar = () => {
      const visible = el => { const r = el.getBoundingClientRect(); return r.top < innerHeight && r.bottom > 0; };
      bar.hidden = hero.getBoundingClientRect().bottom > 0 || visible(purchase) || visible(newsletter) || (form && form.contains(document.activeElement));
    };
    const observer = new IntersectionObserver(updateBar);
    [hero, purchase, newsletter].forEach(el => observer.observe(el));
    window.addEventListener('resize', updateBar);
    if (form) {
      form.addEventListener('focusin', updateBar);
      form.addEventListener('focusout', () => requestAnimationFrame(updateBar));
    }
    updateBar();
  }
  if (form && location.search.includes('customer_posted')) newsletter.scrollIntoView();

  // Anwendungsideen
  const ritualTips = {
    coffee: 'Dein Moment am Morgen: Rühre deine Tagesportion in deinen Kaffee ein. JELUNE eignet sich auch für heiße Getränke.',
    water: 'Ganz unkompliziert: Rühre deine Tagesportion in ein Glas Wasser ein. Die geschmacksneutrale Rezeptur passt auch in kalte Getränke.',
    breakfast: 'Zum Frühstück: Rühre deine Tagesportion zum Beispiel in dein Porridge ein. So wird sie Teil einer Gewohnheit, die du schon hast.'
  };
  const ritualChoices = one('.ritual-choices');
  if (ritualChoices) {
    ritualChoices.hidden = false;
    all('[data-ritual]').forEach(button => button.addEventListener('click', () => {
      all('[data-ritual]').forEach(choice => choice.setAttribute('aria-pressed', String(choice === button)));
      one('#ritual-tip').textContent = ritualTips[button.dataset.ritual];
    }));
  }

  // Sanftes Einblenden, Inhalte bleiben immer sichtbar
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  if ('IntersectionObserver' in window && typeof Element.prototype.animate === 'function') {
    const entrances = new Set();
    const revealObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        revealObserver.unobserve(entry.target);
        if (reducedMotion.matches) return;
        const animation = entry.target.animate(
          [{opacity: .8, transform: 'translateY(8px)'}, {opacity: 1, transform: 'translateY(0)'}],
          {duration: 420, easing: 'ease-out'}
        );
        entrances.add(animation);
        animation.finished.then(() => entrances.delete(animation), () => entrances.delete(animation));
      });
    }, {threshold: .08});
    all('.formula-heading, .formula-pillar, .ritual-image, .ritual-copy, .brand-intent, .newsletter').forEach(el => revealObserver.observe(el));
    reducedMotion.addEventListener('change', event => {
      if (event.matches) entrances.forEach(animation => animation.cancel());
    });
  }
})();
